<template>

  <transition name="fade" tag="div" move-class="fade-move" v-if="days[0].data_atual !== null">

    <div :class="['container', logicaDeIcones(days[0]).bg]"
      v-if="(logicaDeIcones(days[0]).bg !== logicaDeIcones(days[days.length - 1]).bg ? showAll : true)">
      <div class="overlay"></div>

      <div class="content">
        <div class="header">
          <div class="logo">
            <img src="https://res.cloudinary.com/dghjxccks/image/upload/v1763477735/logo-empresa_wb9ozz.png"
              alt="Território da Noticia" class="logo-img">
          </div>
        </div>
        <transition name="fade" tag="div" move-class="fade-move">
          <div class="current-weather" v-if="showAll">
            <div class="location">São Paulo, SP</div>
            <div class="date">{{ getNow(days[0].data_atual) }}</div>

            <img
              :src="logicaDeIcones(days[0]).src"
              :alt="logicaDeIcones(days[0]).alt"
              :class="['weather-icon-main', iconAnimationClass(logicaDeIcones(days[0]))]"
            >

            <div class="temp-minmax">
              <div class="temperature">{{ days[0].temperatura_min }}°</div>
              <span class="temp-separator">/</span>
              <div class="temperature">{{ days[0].temperatura_max }}°</div>
            </div>
            <div class="weather-description">{{ logicaDeIcones(days[0]).alt }}</div>
          </div>
        </transition>
        <div class="weekly-forecast">
          <div class="forecast-title">Previsão da Semana</div>
          <transition name="fade" tag="div" move-class="fade-move">
            <div name="fade" v-if="showAll" class="forecast-days">

              <div class="forecast-day" v-for="(item) in days.slice(1, 100)" :key="item.data_atual">

                <div class="day-name">{{ item.semana_dia }}</div>
                <div class="day-date">{{ item.data_atual }}</div>

                
                <img
                  :src="logicaDeIcones(item).src"
                  :alt="logicaDeIcones(item).alt"
                  :class="['weather-icon-small', iconAnimationClass(logicaDeIcones(item))]"
                >

                <div class="temperatures">
                  <div class="temp-max">{{ item.temperatura_max }}°</div>
                  <div class="temp-min">{{ item.temperatura_min }}°</div>
                </div>
                <div class="rain-probability">{{ item.probabilidade_chuva }}% 💧</div>
              </div>

            </div>
          </transition>



        </div>
      </div>
    </div>

  </transition>
</template>

<script>
import axios from 'axios'
import logicaDeIcones from './logica-de-icones'
export default {
  data() {
    return {
      showAll: false,
      previsaoHoje: {},
      contaSegundos: 0,
      currentIndex: 0,
      interval: null,
      days: [
        { "data_atual": null, "semana_dia": null, "probabilidade_chuva": null, "temperatura_max": null, "temperatura_min": null, "umidade": null, "indice_uv": null },
        // { "data_atual": "13", "semana_dia": "Qua", "probabilidade_chuva": 51, "temperatura_max": "25", "temperatura_min": "10", "umidade": 25, "indice_uv": 7 },
        // { "data_atual": "14", "semana_dia": "Qui", "probabilidade_chuva": 5, "temperatura_max": "19", "temperatura_min": "11", "umidade": 55, "indice_uv": 7 },
        // { "data_atual": "15", "semana_dia": "Sex", "probabilidade_chuva": 55, "temperatura_max": "18", "temperatura_min": "12", "umidade": 59, "indice_uv": 7 },
        // { "data_atual": "16", "semana_dia": "Sáb", "probabilidade_chuva": 5, "temperatura_max": "21", "temperatura_min": "13", "umidade": 51, "indice_uv": 7 },
        // { "data_atual": "17", "semana_dia": "Dom", "probabilidade_chuva": 21, "temperatura_max": "25", "temperatura_min": "13", "umidade": 39, "indice_uv": 7 },
        // { "data_atual": "18", "semana_dia": "Seg", "probabilidade_chuva": 21, "temperatura_max": "25", "temperatura_min": "14", "umidade": 41, "indice_uv": 7 }
      ]

    }
  },
  computed: {
    icone() {
      return this.days[this.currentIndex]
    },
    currentDay() {
      return this.days[this.currentIndex];
    },
    nextDays() {
      return this.days.slice(this.currentIndex + 1).concat(this.days.slice(0, this.currentIndex));
    }
  },
  async mounted() {
    await this.getPrevisaoDoTempo()
    setTimeout(() => {
      this.$emit('end')
    }
      , 15000)
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    logicaDeIcones,
    iconAnimationClass(iconData) {
      if (!iconData || !iconData.alt) return ''
      const alt = iconData.alt.toLowerCase()
      if (alt.includes('neve')) return 'icon-snow'
      if (alt.includes('vento')) return 'icon-wind'
      if (alt.includes('chuva') || alt.includes('raios')) return 'icon-rain'
      if (alt.includes('nublado') || alt.includes('nuvens') || alt.includes('nevoa') || alt.includes('névoa')) {
        return 'icon-clouds'
      }
      if (alt.includes('sol')) return 'icon-sun'
      return ''
    },
    async getPrevisaoDoTempo() {
      try {
        const previsaoHoje = await axios.get('https://www.cptec.inpe.br/api/forecast-input?city=S%C3%A3o%20Paulo%2C%20SP', { timeout: 5000 })
        const previsao = await axios.get('https://www.cptec.inpe.br/api/forecast-input-next-days?city=S%C3%A3o%20Paulo%2C%20SP', { timeout: 5000 });
        const hj = new Date()
        const diaSemana = new Intl.DateTimeFormat('pt-BR', { weekday: 'short' }).format(hj);
        const diaSemanaFormatada = diaSemana[0].toUpperCase() + diaSemana.slice(1, 3)
        this.previsaoHoje = { ...previsaoHoje.data, data_atual: String(new Date().getDate()).padStart(2, 0), semana_dia: diaSemanaFormatada }
        this.days = [this.previsaoHoje, ...previsao.data]
        this.animations()
      } catch (error) {
        setTimeout(() => this.getPrevisaoDoTempo(), 1000);
        console.error(new Error("falha ao buscar dados da previsão do tempo:", error.stack))
      }
    },
    animations() {
      this.showAll = false
      this.$nextTick(() => this.showAll = true)
      // setTimeout(() => {
      //   this.showAll = false
      //   this.$nextTick(() => this.showAll = true)
      //   //this.animations()
      //   this.days.push(this.days.shift())
      // }, 3000)
    },
    getNow(date) {
      const now = new Date();
      const data = new Date(now.getFullYear(), now.getMonth(), date || 1);

      const formato = new Intl.DateTimeFormat('pt-BR', {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      }).format(data);
      return formato.charAt(0).toUpperCase() + formato.slice(1)
    },


  },

}
</script>
<style></style>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.250s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.container {
  width: 1080px;
  height: 1920px;
  position: relative;
  overflow: hidden;
  background: #1a1a2e;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.bg-ceu-limpo {
  background-image: url('https://res.cloudinary.com/dghjxccks/image/upload/v1765561549/sol_background_kvu33e.webp');
  background-size: cover;
  background-position: center;
}

.bg-ceu-nublado {
  background-image: url('https://res.cloudinary.com/dghjxccks/image/upload/v1763475706/nublado_c3tumi.webp');
  background-size: cover;
  background-position: center;
}

.bg-raios-sol {
  background-image: url('https://res.cloudinary.com/dghjxccks/image/upload/v1763475707/sol_cbhinu.webp');
  background-size: cover;
  background-position: center;
}

.bg-chuva {
  background-image: url('https://res.cloudinary.com/dghjxccks/image/upload/v1765561670/chuva_background_uwu6n3.webp');
  background-size: cover;
  background-position: center;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0.6) 100%);
  z-index: 1;
}

.content {
  position: relative;
  z-index: 10;
  height: calc(100% - 120px);
  display: flex;
  flex-direction: column;
  padding: 60px;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 80px;
}

.logo {
  background: #ffffff;
  backdrop-filter: blur(20px);
  padding: 30px 50px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-img {
  max-height: 100px;
  max-width: 400px;
  object-fit: contain;
}

.current-weather {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  margin-bottom: 80px;
}

.location {
  font-size: 56px;
  font-weight: 700;
  margin-bottom: 15px;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.date {
  font-size: 32px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 60px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.weather-icon-main {
  width: 280px;
  height: 280px;
  margin-bottom: 50px;
  filter: drop-shadow(0 10px 40px rgba(0, 0, 0, 0.4));
  object-fit: contain;
}

.temperature {
  font-size: 180px;
  font-weight: 300;
  line-height: 1;
  margin-bottom: 20px;
  text-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
}

.weather-description {
  font-size: 42px;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);
}

.temp-minmax {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.temp-separator {
  font-size: 120px;
  font-weight: 200;
  color: rgba(255, 255, 255, 0.5);
}

.weekly-forecast {
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(30px);
  border-radius: 40px;
  padding: 50px;
}

.forecast-title {
  color: white;
  font-size: 42px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 40px;
}

.forecast-days {
  display: grid;
  grid-template-columns: repeat(6, 2fr);
  gap: 20px;
  width: 100%;
  position: relative;
}

.forecast-day {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 25px;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.day-name {
  color: rgba(255, 255, 255, 0.9);
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 20px;
}

.day-date {
  color: rgba(255, 255, 255, 0.7);
  font-size: 20px;
  margin-bottom: 25px;
}

.weather-icon-small {
  width: 80px;
  height: 80px;
  margin-bottom: 25px;
  object-fit: contain;
}

.temperatures {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
}

.temp-max {
  color: white;
  font-size: 36px;
  font-weight: 600;
}

.temp-min {
  color: rgba(255, 255, 255, 0.6);
  font-size: 26px;
}

.rain-probability {
  color: #60a5fa;
  font-size: 22px;
  margin-top: 5px;
}

.icon-sun {
  animation: sun-rotate 18s linear infinite, sun-pulse 3.5s ease-in-out infinite;
  transform-origin: center;
}

.icon-clouds {
  animation: clouds-drift 3s ease-in-out infinite;
}

.icon-rain {
  animation: rain-bob 2.2s ease-in-out infinite;
}

.icon-wind {
  animation: wind-sway 3s ease-in-out infinite;
}

.icon-snow {
  animation: snow-float 4s ease-in-out infinite;
}

.weather-icon-small.icon-sun {
  animation-duration: 24s, 4.5s;
}

.weather-icon-small.icon-clouds {
  animation-duration: 7.5s;
}

.weather-icon-small.icon-rain {
  animation-duration: 2.6s;
}

.weather-icon-small.icon-wind {
  animation-duration: 3.5s;
}

.weather-icon-small.icon-snow {
  animation-duration: 5s;
}

@keyframes sun-rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes sun-pulse {
  0%, 100% { filter: drop-shadow(0 10px 35px rgba(255, 200, 0, 0.45)); }
  50% { filter: drop-shadow(0 14px 45px rgba(255, 220, 0, 0.7)); }
}

@keyframes clouds-drift {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(12px); }
}

@keyframes rain-bob {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(8px); }
}

@keyframes wind-sway {
  0%, 100% { transform: translateX(0) rotate(0deg); }
  50% { transform: translateX(6px) rotate(2deg); }
}

@keyframes snow-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(6px); }
}

@media (prefers-reduced-motion: reduce) {
  .icon-sun,
  .icon-clouds,
  .icon-rain,
  .icon-wind,
  .icon-snow {
    animation: none !important;
  }
}
</style>
